var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z",
    fill: "#A9A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.51a8e71882dd7db0fece09d10f684735.svg";
export { ForwardRef as ReactComponent };